/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Bar } from "react-chartjs-2";
import Select from 'react-select'
import { Chart, CategoryScale, LinearScale, BarElement, Legend, Title, Tooltip } from 'chart.js';
import Key from '../../src/clientVariables.json'
Chart.register(
    LinearScale, CategoryScale, BarElement, Legend, Title, Tooltip
)





function CompaniesBar() {
    const [companies, setCompanies] = useState([])
    const [companyJobsCount, setCompanyJobsCount] = useState([])

    useEffect(() => {
        fetch(`${Key.domain}/company/getCompanyJobsCount`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            response.json().then(async (resdata) => {
                if (resdata.data.length > 0) {
                    setCompanies(resdata.data.map(data => data.name))
                    setCompanyJobsCount(resdata.data.map(data => data.jobscountpostedbycompany))

                }
            });
        });


    }, [])


    const labels =companies

    const options = {
        plugins: {
            legend: {
                position: 'top'
            },
            title: {
                display: true,
                text: "Count of jobs posted by each company in the past 24 hours",
                color: '#406882',
                align: "start",
                font: {
                    size: 20
                }

            }
        }
    }

    const data = {
        labels,
        datasets: [
            {
                label: 'Jobs',
                data: companyJobsCount,
                backgroundColor: '#d7ecfb'
            },
        ],
    };

    return (
        <div>
            <Bar options={options} data={data} />
        </div>
    )
}

export default CompaniesBar